<template>
    <div>
        <div class="columns is-multiline is-centered" style="border-bottom:#ddd solid 0.8px;">
            <div class="column is-full">
                <a v-if="!isNew"
                    @click="deleteCard"
                    class="has-text-danger">
                    <b-icon icon="trash" size="is-small"></b-icon>
                    Delete
                </a>
            </div>
            <div class="column is-half has-text-centered">
                <b-field label="Imagen">
                    <b-upload
                    v-model="image"
                    drag-drop
                    @input="encodeImage">
                        <section class="section" >
                            <div class=" has-text-centered">
                                <p>
                                    <b-icon
                                        icon="upload"
                                        size="is-large">
                                    </b-icon>
                                </p>
                                <p>Arrastra aqui las imagenes o haz click.</p>
                            </div>
                        </section>
                    </b-upload>
                </b-field>
                <div v-if="image" class="tags has-text-centered">
                    <span
                        class="tag is-primary" >
                        {{image.name}}
                        <button class="delete is-small"
                            type="button"
                            @click="deleteDropFile">
                        </button>
                    </span>
                </div>
            </div>
            <div v-if="data.image" class="column is-half has-text-centered">
                <img v-if="data.image" class="case" :src="data.image" alt="">
            </div>
            <div class="column is-two-thirds has-text-centered">
                <b-field label="Titulo">
                    <b-input
                    required
                    @input="updated"
                    v-model="data.title">
                    </b-input>
                </b-field>
            </div>
            <div class="column is-two-thirds has-text-centered">
                <b-field label="Sobre ellos">
                    <b-input
                    required
                    type="textarea"
                    @input="updated"
                    v-model="data.aboutThem">
                    </b-input>
                </b-field>
            </div>
            <div class="column is-two-thirds has-text-centered">
                <b-field label="Lo que dicen sobre nosotros.">
                    <b-input
                    required
                    type="textarea"
                    @input="updated"
                    v-model="data.whatTheySay">
                    </b-input>
                </b-field>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        data:{
            type:Object,
            default: new Object({})
        },
        index:{
            type:Number,
            default:0,
        },
        isNew:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return{
            image:""
        }
    },
    methods:{
        encodeImage(){
            let reader = new FileReader();
            reader.readAsDataURL(this.image);
            reader.onloadend = (event) => {
                this.data.image = reader.result
                this.updated()
            }
        },
        deleteDropFile(){
            this.image = ""
            this.data.image = ""
        },
        deleteCard(){
            this.$emit("deleteElement", {isNew:this.isNew, id:this.data.id})
        },
        updated(){
            if (!this.isNew){
                this.$emit("updated", {id:this.data.id,  index:this.index})
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.case{
    max-height: 250px;
    border:1px solid #ddd;
    border-radius: 5px;
}
</style>